<template>
  <section class="c-category-section">
    <h2 class="c-category-section__title">
      {{ optionCategory.name }}
    </h2>
    <button
      v-if="extraInfo"
      @click="toggleModal"
      class="c-btn c-btn--invisible u-margin-bottom"
    >
      {{ optionCategory.description }}
    </button>
    <p
      v-else
    >
      {{ optionCategory.description }}
    </p>
    <modal
      v-if="showModal"
      @close="toggleModal"
      class="c-modal--narrow"
    >
      <h2>{{ optionCategory.longTitle }}</h2>
      <div v-html="optionCategory.longDescription" />
    </modal>
    <OptionComponent
      v-for="option in options"
      :key="option.id"
      :optionId="option.id"
      :residenceId="residenceId"
    />
  </section>
</template>

<script>
// VUEX Modules
import Option from '@/models/Option';
import OptionCategory from '@/models/OptionCategory';

import OptionComponent from '@/components/Option.vue';
import Modal from '@/components/Modal.vue';

export default {
  name: 'CategorySection',
  components: {
    OptionComponent,
    Modal,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    residenceId: {
      type: [
        Number,
        String,
        Boolean,
      ],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    optionCategory() {
      return OptionCategory.find(this.categoryId);
    },
    options() {
      return Option.query()
        .where('option_category_id', this.categoryId)
        .get();
    },
    extraInfo() {
      return this.optionCategory.extraInfo;
    },
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
  },
};
</script>

